import { SUB_DOMAIN } from '@/constants/domain';

export const TEST_CHANNEL_COOKIE = 'wello-test-channel';

export const SUB_DOMAIN_BY_TEST_CHANNEL = {
  WELLO: SUB_DOMAIN.WELLO,
  KB_PAY: SUB_DOMAIN.KB_PAY,
  KAKAO_BANK: SUB_DOMAIN.KAKAOBANK,
  TOSS: SUB_DOMAIN.TOSS,
} as const;

export type TestChannel = keyof typeof SUB_DOMAIN_BY_TEST_CHANNEL;

//* 쿠키 값의 `:` 는 인코딩돼 서버·document.cookie 가 다르게 읽는다 — 인코딩되지 않는 `.` 로 잇는다
const TEST_CHANNEL_PATTERN = /^(WELLO|KB_PAY|KAKAO_BANK|TOSS)\.(\d+)$/;

//* 테스트 채널 스위치의 유일한 게이트 — next dev(localhost)에서만 켜지고 배포 빌드(production)에서는 꺼진다
export const isTestChannelEnabled = () =>
  process.env.NODE_ENV === 'development';

export const parseTestChannel = (value: string | undefined) => {
  const match = TEST_CHANNEL_PATTERN.exec(value ?? '');

  if (!match) {
    return null;
  }

  return {
    channel: match[1] as TestChannel,
    memberOAuthId: Number(match[2]),
  };
};

export const formatTestChannel = ({
  channel,
  memberOAuthId,
}: {
  channel: TestChannel;
  memberOAuthId: number;
}) => `${channel}.${memberOAuthId}`;

export const toTestChannelSubDomain = (channel: TestChannel) =>
  SUB_DOMAIN_BY_TEST_CHANNEL[channel];
